/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Title.scss'
import React from 'react'
import { pure } from 'recompose'

function Title(props) {
  return <h1 className="title">{props.children}</h1>
}

export default pure(Title)
